import { DislikeFilled, LikeFilled } from '@ant-design/icons'
import { Descriptions, Modal, Spin, Typography } from 'antd'
import dayjs from 'dayjs'
import { useRatingQuery } from './ratingsQueries'

type Props = {
  ratingId: string | null
  onClose: () => void
  onOpenChat?: (conversationId: string) => void
}

const RatingDetailModal = ({ ratingId, onClose, onOpenChat }: Props) => {
  const { data, isLoading } = useRatingQuery(ratingId)

  return (
    <Modal
      open={!!ratingId}
      onCancel={onClose}
      footer={null}
      title="Response Rating"
      width={720}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      {isLoading && (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      )}
      {data && (
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label="Rating">
            {data.thumbs_up ? (
              <LikeFilled style={{ color: '#52c41a', fontSize: 18 }} />
            ) : (
              <DislikeFilled style={{ color: '#ff4d4f', fontSize: 18 }} />
            )}{' '}
            {data.thumbs_up ? 'Thumbs up' : 'Thumbs down'}
          </Descriptions.Item>
          <Descriptions.Item label="User">{data.user_name}</Descriptions.Item>
          <Descriptions.Item label="Created">
            {dayjs(data.created_at).format('MMM D, YYYY h:mm A')}
          </Descriptions.Item>
          <Descriptions.Item label="Conversation">
            {onOpenChat ? (
              <Typography.Link
                onClick={() => onOpenChat(data.conversation_id)}
                style={{ fontFamily: 'monospace', fontSize: 12 }}
              >
                {data.conversation_id}
              </Typography.Link>
            ) : (
              <Typography.Text
                copyable={{ text: data.conversation_id }}
                style={{ fontFamily: 'monospace', fontSize: 12 }}
              >
                {data.conversation_id}
              </Typography.Text>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Tenant">
            {data.tenant_name ?? <Typography.Text type="secondary">—</Typography.Text>}
            <br />
            <Typography.Text
              copyable={{ text: data.tenant_id }}
              type="secondary"
              style={{ fontFamily: 'monospace', fontSize: 12 }}
            >
              {data.tenant_id}
            </Typography.Text>
          </Descriptions.Item>
          <Descriptions.Item label="User ID">
            <Typography.Text
              copyable={{ text: data.user_id }}
              style={{ fontFamily: 'monospace', fontSize: 12 }}
            >
              {data.user_id}
            </Typography.Text>
          </Descriptions.Item>
          <Descriptions.Item label="Response">
            <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', marginBottom: 0 }}>
              {data.response_text}
            </Typography.Paragraph>
          </Descriptions.Item>
          <Descriptions.Item label="Rationale">
            {data.rationale ? (
              <Typography.Paragraph style={{ whiteSpace: 'pre-wrap', marginBottom: 0 }}>
                {data.rationale}
              </Typography.Paragraph>
            ) : (
              <Typography.Text type="secondary">—</Typography.Text>
            )}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  )
}

export default RatingDetailModal
